export const operatorRoutes = [
  { link: "/perfil/operador", label: "Editar dados" }
];

export const doctorRoutes = [
  { link: "/profile", label: "Perfil" },
  { link: "/dashboard", label: "Minhas consultas" }
];

export const patientRoutes = [
  { link: "/profile", label: "Perfil" },
  { link: "/dashboard", label: "Minhas consultas" }
];

export const receptionistRoutes = [
  { link: "/profile", label: "Perfil" },
  { link: "/dashboard", label: "Minhas consultas" },
  { link: "/nurseschedule", label: "Marcar consulta" }
];

export const operatorTopbarRoutes = [
  { link: "/mapa", label: "Mapa" },
  { link: "/cadastro-operador", label: "Cadastrar operador" },
  { link: "/graficos", label: "Gráficos" },
  { link: "/institucional/usuarios", label: "Usuários" },
  { link: "/alertas", label: "Alertas" }
];

export const doctorTopbarRoutes = [
  { link: "/dashboard", label: "Resumo", userRole: "doctor" },
  { link: "/configurar-agenda", label: "Agenda", userRole: "doctor" },
  { link: "/cadastro-parceiro", label: "Seja um parceiro", userRole: "doctor" },
  {
    link: "/indicar-para-amigos",
    label: "Indicar para amigos",
    userRole: "doctor"
  }
];

export const patientTopbarRoutes = [
  { link: "/dashboard", label: "Resumo", userRole: "patient" },
  {
    link: "/cadastro-parceiro",
    label: "Seja um parceiro",
    userRole: "patient"
  },
  {
    link: "/indicar-para-amigos",
    label: "Indicar para amigos",
    userRole: "patient"
  }
];

export const receptionistTopBarRoutes = [
  { link: "/dashboard", label: "Resumo", userRole: "receptionist" },
  { link: "/profissionais", label: "Profissionais", userRole: "receptionist" },
  {
    link: "/cadastro-parceiro",
    label: "Seja um parceiro",
    userRole: "receptionist"
  },
  {
    link: "/indicar-para-amigos",
    label: "Indicar para amigos",
    userRole: "receptionist"
  }
];

export const getRoutes = userRole => {
  if (userRole === "operator") return operatorRoutes;
  if (userRole === "doctor") return doctorRoutes;
  if (userRole === "patient") return patientRoutes;
  if (userRole === "receptionist") return receptionistRoutes;
};

export const getTopbarRoutes = userRole => {
  if (userRole === "operator") return operatorTopbarRoutes;
  if (userRole === "doctor") return doctorTopbarRoutes;
  if (userRole === "patient") return patientTopbarRoutes;
  if (userRole === "receptionist") return receptionistTopBarRoutes;
};
